import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { License } from '../types/License';
import { TableView } from './generic/tableview/TableView';
import { FunctionAction } from './generic/tableview/actions/FunctionAction';
import * as Constants from '../constants';
import { downloadFile } from '../apiFunctions/downloadFile';

interface LicensesProps {
    setStage: (stage: "EnterActivationKey" | "SelectUnits" | "Licenses") => void,
    licenses: License[] | undefined,
    licenseXml: string,
    useModuleKey: boolean
}

export const Licenses: React.FC<LicensesProps> = props => {
    const { setStage, licenses, licenseXml, useModuleKey } = props;
    const [downloading, setDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const downloadCertificate = (moduleKey: string, productId: number) => {
        setDownloading(true);
        downloadFile(Constants.API_MODULE_INFORMATION_URL + '/certificate/' + moduleKey + "/" + productId,
            setDownloading, setErrorMessage, () => { }, 'LicenseCertificate_' + moduleKey + '.pdf');
    }

    const downloadLicenseFile = () => {
        if (licenseXml === "") return;

        var link = document.createElement('a');
        link.download = 'Licenses.xml';
        var blob = new Blob([licenseXml], { type: 'text/plain' });
        link.href = window.URL.createObjectURL(blob);
        link.click();
    }

    return <React.Fragment>
        {!useModuleKey && licenses && licenses.length > 0 && <Container className="mb-3 mt-3">
            <Row>
                <Col>
                    <TableView
                        headers={["Serial number", "License key"]}
                        data={licenses.map((license, index) => {
                            return {
                                id: index,
                                entity: license,
                                cellContent: [license.serialNumber, license.licenseKey.match(/.{1,4}/g)?.join(' ')]
                            }
                        })}
                        actions={[]}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button className="button" onClick={() => { downloadLicenseFile(); }}>Download license file</Button>
                </Col>
            </Row>
        </Container>}

        {useModuleKey && licenses && licenses.length > 0 && <Container className="mb-3 mt-3">
            <Row>
                <Col>
                    <TableView
                        headers={["Module key"]}
                        data={licenses.map((license, index) => {
                            return {
                                id: index,
                                entity: license,
                                cellContent: [license.moduleKey]
                            }
                        })}
                        actions={[{
                            text: "Download certificate",
                            icon: "download",
                            enabled: true,
                            actionFunction: (license: License) => { downloadCertificate(license.moduleKey, license.productId); }
                        } as FunctionAction]}
                    />
                </Col>
            </Row>
        </Container>}

        <Button className="button" onClick={() => { setStage("EnterActivationKey"); }}>
            Start over
        </Button>
    </React.Fragment>;
}

